import { Dialog } from 'primereact/dialog';
import { useState, useEffect, useRef } from "react";
import { Tag } from 'primereact/tag';
import {localurl} from '../constant';
import { FcBearish } from "react-icons/fc";
import { FcBullish } from "react-icons/fc";



export const Label = ({name,classstyle}) =>{
    return (
        <>
           <label for="name" className={`label-style ${classstyle}`}
><i className="fa fa-star txt-mandate" style={{fontSize:'6px'}}></i>  <b>{name}</b></label> 
        </>
    ); 
}


export const Titlebar = ({text}) =>{
    return (
        <>
            <div className="col-md-12">
                  <h2 className="primary-text-color primary-titlebar-style">{text}</h2>
              </div>
        </>
    ); 
}


export const Searchbox = ({ value, onChange }) =>{
    return (
        <>
            <div class="input-group search-box-style">
                        <input type="text" class="form-control rounded-pill" value={value} onChange={onChange} placeholder="Search..."/>
                <span class="input-group-text bg-white border-0 input-search-icon">
                    <i class="fas fa-search"></i> 
                </span>
            </div>
        </>
    ); 
}

export const Confirmdialog = ({popvisible,setPopvisible,fun,id}) =>{
    // console.log(popvisiblei);
    //  const [popvisiblei,setPopvisible] = useState(popvisible);

     return (
             <Dialog
        header="⚠️ Confirm Deletion"
        visible={popvisible}
        style={{ width: '30vw', borderRadius: '10px' }}
        onHide={() => setPopvisible(false)}
        modal
    >
        <p className="mb-4" style={{ fontSize: '1rem' }}>
        Are you sure you want to delete this component?
        </p>

        <div className="d-flex justify-content-end gap-2">
        <button
            className="btn btn-secondary rounded-pill px-4"
            onClick={() => setPopvisible(false)}
        >
            Cancel
        </button>
        <button
            className="btn btn-danger rounded-pill px-4"
            onClick={() => fun(id)}
        >
            Delete
        </button>
        </div>
    </Dialog>
     );
    
}

export const Confirmdialog2 = ({popvisible,setPopvisible,fun,id,stocktype}) =>{
    // console.log(popvisiblei);
    //  const [popvisiblei,setPopvisible] = useState(popvisible);

     return (
             <Dialog
        header="⚠️ Confirm Deletion"
        visible={popvisible}
        style={{ width: '30vw', borderRadius: '10px' }}
        onHide={() => setPopvisible(false)}
        modal
    >
        <p className="mb-4" style={{ fontSize: '1rem' }}>
        Are you sure you want to delete this component?
        </p>

        <div className="d-flex justify-content-end gap-2">
        <button
            className="btn btn-secondary rounded-pill px-4"
            onClick={() => setPopvisible(false)}
        >
            Cancel
        </button>
        <button
            className="btn btn-danger rounded-pill px-4"
            onClick={() => fun(id,stocktype)}
        >
            Delete
        </button>
        </div>
    </Dialog>
     );
    
}

export const Stockstatus = ({status = ''}) =>{
    switch(status){
       case 'available':
          return <Tag severity="success" value="Available"></Tag>  
       break;

       case 'expired':
          return <Tag severity="danger" value="Expired"></Tag>  
       break;

       default:
          return <></>
         ;   
    } 
    
}

export const Billofmaterialstatus = ({status = ''}) =>{
    switch(status){
       case 'approved':
          return <Tag severity="success" value="Approved"></Tag>  
       break;

       case 'unapproved':
          return <Tag severity="danger" value="Unapproved"></Tag>  
       break;

       default:
          return <></>
         ;   
    } 
    
}

export const Importexceldata = ({ visible, onHide, onSubmit,samplepath,loading })=>{
                return <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={onHide}>
                    <div className="container py-5">
                      <div className="card shadow-lg rounded-4 p-4">
                        <h2 className="mb-4 text-center text-primary">Excel Multiple Data Upload</h2>
        
                        <div className="text-center mb-4">
                          <a
                            href={localurl + "/templates/"+samplepath}
                            download
                            className="btn btn-outline-primary rounded-pill px-4"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Download Excel Template
                          </a>
                        </div>
        
                        <form id="uploadForm" onSubmit={onSubmit}>
                          <div className="mb-3">
                            <label htmlFor="file" className="form-label fw-semibold">
                              Upload Excel File
                            </label>
                            <input
                              type="file"
                              className="form-control form-control-lg"
                              id="file"
                              name="file"
                              accept=".xlsx, .xls"
                              required
                            />
                          </div>
        
                          <div className="text-center">
                        <button
                                type="submit"
                                className="btn btn-primary rounded-pill px-5 py-2 custom-btn-color"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                                        Uploading...
                                    </>
                                ) : (
                                    "Upload"
                                )}
                            </button>
                          </div>
                        </form>
        
                        <div id="status" className="status mt-4 text-center text-success fw-medium"></div>
                      </div>
                    </div>
        
                </Dialog>
    }
export const Stockstatusavailability = ({status = ''}) =>{
    switch(status){
       case 'lowstock':
          return <Tag severity="warning" value="Low-Stock"></Tag>  
       break;

       case 'instock':
          return <Tag severity="success" value="In-Stock"></Tag>  
       break;

       case 'outofstock':
          return <Tag severity="danger" value="Out Of Stock"></Tag>  
       break;

       case 'overstock':
          return <Tag severity="info" value="Over Stock"></Tag>  
       break;

       default:
          return <>{status}</>
         ;   
    }       
}


export const Shipmentstatus = ({status = ''}) =>{
    switch(status){
       case 'dispatched':
          return <Tag severity="warning" value="Dispatched"></Tag>  
       break; 
       case 'in_transit':
          return <Tag severity="info" value="In Transit"></Tag>  
       break;

       case 'pending':
          return <Tag severity="warning" value="Pending"></Tag>  
       break;

       case 'delivered':
          return <Tag severity="success" value="Delivered"></Tag>  
       break;

       case 'overstock':
          return <Tag severity="info" value="Over Stock"></Tag>  
       break;

       default:
          return <></>
         ;   
    }       
}


export const Orderstatus = ({status = ''}) =>{
    switch(status){
       case 'Confirmed':
          return <Tag severity="warning" value="Confirmed"></Tag>  
       break; 
       case 'Cancelled':
          return <Tag severity="danger" value="Cancelled"></Tag>  
       break;

       case 'Packed':
          return <Tag severity="info" value="Packed"></Tag>  
       break;

       case 'Shipped':
          return <Tag severity="success" value="Shipped"></Tag>  
       break;

       case 'delivered':
          return <Tag severity="success" value="Delivered"></Tag>  
       break;

       case 'overstock':
          return <Tag severity="info" value="Over Stock"></Tag>  
       break;



       default:
          return <>{status}</>
         ;   
    }       
}

export const Confirmdelete = ({popvisible,cancel,deletefun,title}) =>{
     return (
             <Dialog
        header="⚠️ Confirm Deletion"
        visible={popvisible}
        style={{ width: '30vw', borderRadius: '10px' }}
        onHide={cancel}
        modal
    >
        <p className="mb-4" style={{ fontSize: '1rem' }}>
        Are you sure you want to delete this {title}?
        </p>

        <div className="d-flex justify-content-end gap-2">
        <button
            className="btn btn-secondary rounded-pill px-4"
            onClick={cancel}
        >
            Cancel
        </button>
        <button
            className="btn btn-danger rounded-pill px-4"
            onClick={deletefun}
        >
            Delete
        </button>
        </div>
    </Dialog>
     );
    
}


export const Confirmdelete2 = ({popvisible,cancel,deletefun,title,id}) =>{
     return (
             <Dialog
        header="⚠️ Confirm Deletion"
        visible={popvisible}
        style={{ width: '30vw', borderRadius: '10px' }}
        onHide={cancel}
        modal
    >
        <p className="mb-4" style={{ fontSize: '1rem' }}>
        Are you sure you want to delete this {title}?
        </p>

        <div className="d-flex justify-content-end gap-2">
        <button
            className="btn btn-secondary rounded-pill px-4"
            onClick={cancel}
        >
            Cancel
        </button>
        <button
            className="btn btn-danger rounded-pill px-4"
            onClick={() => deletefun(id)}
        >
            Delete
        </button>
        </div>
    </Dialog>
     );
    
}

export const ProfitLoss = ({status}) =>{
    switch(status){
       case 'profit':
          return <FcBullish style={{fontSize:'33px'}}/>  
       break; 
       case 'loss':
          return <FcBearish style={{fontSize:'33px'}}/>  
       break;

       default:
          return <>{status}</>
         ;   
    }    
} 

export const Activiystatus = ({status}) =>{
      switch(status){
       case 'Inactive':
          return <Tag severity="error" value={status}></Tag>  
       break; 
       case 'Active':
          return <Tag severity="success" value={status}></Tag>  
       break;

       default:
          return <></>
         ;   
    }  
}
